/*
 * @adonisjs/application
 *
 * (c) AdonisJS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import type { RcFileInput } from './types.js'

/**
 * Define rcFile config
 */
export function defineConfig(config: RcFileInput): RcFileInput {
  return config
}
